var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.busyPage == true)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-three-bounce"},[_c('div',{staticClass:"sk-child sk-bounce1"}),_c('div',{staticClass:"sk-child sk-bounce2"}),_c('div',{staticClass:"sk-child sk-bounce3"})])
}]

export { render, staticRenderFns }